/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2012 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { orderdetailobject } from './orderdetail';
import { paymentrequest } from './paymentrequest';
import { IceTypes } from '../icetypes';

export class orderobject extends IceEntity {
  order_id: number= 0;
  order_key: string = "";
  date: any = NaN;
  login_user_name: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  discount: number = 0.0;
  total: number = 0.0;
  newuser: boolean = false;
  payment_response: string = "";
  other_fees: number = 0.0;
  sub_total: number = 0.0;

  company_name: string = "";
  company_country_code: string = "";
  company_phone: string = "";

  customer_contact_name: string = "";
  customer_company_name: string = "";
  customer_address: string = "";
  customer_city: string = "";
  customer_state: string = "";
  customer_province: string = "";
  customer_postal_code: string = "";
  customer_country_code: string = "";
  customer_phone: string = "";
  customer_email: string = "";
  customer_currency_code: string = "";

  original_currency_total: number = 0.0;

  PAYMENT_REQUEST: paymentrequest[] = null;
  ORDER_DETAILS: orderdetailobject[] = [];

  gettablename(): string {
    return "ORDER";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "PAYMENT_REQUEST") return true;
    else if (ColumnName == "ORDER_DETAILS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "PAYMENT_REQUEST") return "PAYMENT_REQUEST";
    else if (ColumnName == "ORDER_DETAILS") return "ORDER_DETAIL";

    return null;
  }
}
